import React, { memo } from 'react'

import { Button, Icon, Search } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'

function NoResults({ onCreate }) {
  return (
    <div className="image-assistant-panel__state">
      <div className="image-assistant-panel__empty-icon">
        <Icon svgComponent={Search} size={iconSizeMedium} color="dark" notSpaced />
      </div>
      <div className="image-assistant-panel__empty-text">
        <p className="image-assistant-panel__state-title cgt-heading-200">
          Nothing found
        </p>
        <p className="image-assistant-panel__state-subtitle cgt-body-md">
          Try creating a reference image using your prompt
        </p>
      </div>
      <Button type="secondary" size="small" onClick={onCreate}>
        Create Image
      </Button>
    </div>
  )
}

NoResults.propTypes = {
  onCreate: func.isRequired,
}

export default memo(NoResults)
